import { formatStatus } from "@/lib/api";

const STYLES = {
  "Draft": "bg-slate-100 text-slate-700 border-slate-300",
  "Under Review": "bg-amber-50 text-amber-800 border-amber-200",
  "Sourcing": "bg-sky-50 text-sky-800 border-sky-200",
  "Quoting": "bg-violet-50 text-violet-800 border-violet-200",
  "Comparison": "bg-indigo-50 text-indigo-800 border-indigo-200",
  "Awarded": "bg-emerald-50 text-emerald-800 border-emerald-200",
  "Delivered": "bg-emerald-100 text-emerald-900 border-emerald-300",
  "Closed": "bg-slate-200 text-slate-800 border-slate-400",
  "Prepared": "bg-indigo-50 text-indigo-800 border-indigo-200",
  "Selected": "bg-emerald-50 text-emerald-800 border-emerald-200",
  "Declined": "bg-rose-50 text-rose-800 border-rose-200",
  "Invited": "bg-amber-50 text-amber-800 border-amber-200",
  "Quoted": "bg-sky-50 text-sky-800 border-sky-200",
  "Submitted": "bg-sky-50 text-sky-800 border-sky-200",
  "Pending": "bg-slate-100 text-slate-700 border-slate-300",
  "Paid": "bg-emerald-50 text-emerald-800 border-emerald-200",
  "Confirmed": "bg-sky-50 text-sky-800 border-sky-200",
  "In Transit": "bg-violet-50 text-violet-800 border-violet-200",
  "Invoiced": "bg-amber-50 text-amber-800 border-amber-200",
  "Not Selected": "bg-rose-50 text-rose-800 border-rose-200",
  "Locked": "bg-slate-200 text-slate-800 border-slate-400",
};

export default function StatusBadge({ status }) {
  const label = formatStatus(status);
  const cls = STYLES[label] || "bg-slate-100 text-slate-700 border-slate-300";
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${cls}`}
      data-testid={`status-${String(status ?? "").toLowerCase()}`}
      title={label}
    >
      {label}
    </span>
  );
}
